import { jsx as _jsx } from "react/jsx-runtime";
import Image from 'next/legacy/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { Wrapper } from './styles';
import { CalmLogoColor } from './types';
const ASPECT_RATIO = 216 / 84;
const CalmLogo = ({ className, height = 40, href = '/', color = CalmLogoColor.White, loader, preserveQueryParams = true, 'aria-label': ariaLabel = 'Calm Logo - Link to Homepage', }) => {
    var _a;
    const query = (_a = useRouter()) === null || _a === void 0 ? void 0 : _a.query;
    const linkHref = preserveQueryParams ? { pathname: href, query } : href;
    const width = height * ASPECT_RATIO;
    const src = color === CalmLogoColor.White ? '/_n/images/calm-logo.svg' : '/_n/images/calm-logo-gradient.svg';
    return (_jsx(Link, { passHref: true, href: linkHref, legacyBehavior: true, children: _jsx(Wrapper, { className: className, "$height": height, children: _jsx(Image, { width: width, height: height, src: src, loader: loader, alt: "Calm logo", unoptimized: true, "aria-label": ariaLabel }) }) }));
};
export default CalmLogo;
//# sourceMappingURL=index.js.map